import { Helmet } from 'react-helmet';
import Router from './views/Router';
import { Store } from './components';
import './styles/main.scss';
import { loadBernierFont } from './utilities/load-bernier-font';
// Gotham Book y Bold aparecen en el primer pantallazo de todas las páginas. Con el relevo del
// prerender (utilities/prerender-handoff.js) el texto se ve de inmediato, así que precargarlas
// evita que se muestre primero con la fuente genérica. Mismos archivos que fonts.scss.
import gothamBook from './assets/fonts/Gotham/Gotham-Book.woff2';
import gothamBold from './assets/fonts/Gotham/Gotham-Bold.woff2';

// Cargar la fuente Bernier Distressed después del primer pintado (Fase 7 R7-4)
loadBernierFont();

const App = () => (
    <Store>
        <Helmet>
            <link rel='preload' as='font' type='font/woff2' href={gothamBook} media='(min-width: 769px)' crossOrigin='anonymous' />
            <link rel='preload' as='font' type='font/woff2' href={gothamBold} media='(min-width: 769px)' crossOrigin='anonymous' />
        </Helmet>
        <Router />
    </Store>
);

export default App;
